import { Controller } from '@hotwired/stimulus';

import $ from 'jquery';
import Select2 from 'select2';

import 'select2/dist/css/select2.css';

Select2();

export default class Select2Controller extends Controller {
  connect() {
    $(this.element).select2({
      language: {
        errorLoading() {
          return '結果が読み込まれませんでした';
        },

        inputTooLong(n) {
          return `${n.input.length - n.maximum}文字を削除してください`;
        },

        inputTooShort(n) {
          return `少なくとも${n.minimum - n.input.length}文字を入力してください`;
        },

        loadingMore() {
          return '読み込み中…';
        },

        maximumSelected(n) {
          return `${n.maximum}件しか選択できません`;
        },

        noResults() {
          return '対象が見つかりません';
        },

        searching() {
          return '検索しています…';
        },

        removeAllItems() {
          return 'すべてのアイテムを削除';
        }
      }
    });

    $(this.element).on('select2:select', (e) => {
      this.dispatch('change', {detail: {originalEvent: e}});
    });
  }

  disconnect() {
    $(this.element).select2('destroy');
  }
}
